import React, {useState} from 'react';
import { NavLink } from 'react-router-dom';
import { ParallaxBanner, ParallaxBannerLayer } from "react-scroll-parallax";
import { HashLink } from 'react-router-hash-link';
import { Modal } from "@mui/base";
import { Box } from '@mui/material';
import Accordion from 'react-bootstrap/Accordion';

const AdvancedBanner = ({ urlImage, title, description, cta, item }) => {
    const [isPriceListView, setIsPriceListView] = useState(false);

    return (
        <ParallaxBanner style={{ aspectRatio: '2 / 1' }} className={` sectionSliderPage backgroundOverlay`}>
            {urlImage && (
                <ParallaxBannerLayer
                    expanded={false}
                    translateY={[0, -30]}
                    speed={-20}
                    image={`${process.env.REACT_APP_SITE_URL + urlImage}`}
                    opacity={[0, 1, "easeOutCubic"]}
                >
                </ParallaxBannerLayer>
            )}

            <ParallaxBannerLayer >
                <div className="container-fluid h-100 position-relative">
                    <div className="boxHeading2 boxHeading4"></div>
                    <div className="boxHeading boxHeading3"></div>
                    <div className="box50">
                        <div className="container-fluid h-100 position-relative d-flex align-items-end justify-content-center pe-4">
                            <div className="d-flex flex-column">
                                <h2 className="title text-white text-center parallax-layer-adv-banner-title-position">
                                    {title}
                                </h2>
                            </div>
                        </div>
                        <div
                            className="text-white d-flex flex-column p-no-margin parallax-custom position-relative col-lg-9 col-11 mx-auto justify-content-center align-items-center pe-4"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                        <div className="contentSlider mb-3 text-center w-100 mt-100px pe-4">
                            {
                                (item && item?.priceLists && item?.priceLists.length > 0) ? (
                                    <> 
                                        <button
                                            onClick={() => setIsPriceListView(true)}
                                            className="bg-transparent border-none lineEffect text-uppercase text-white"
                                        >
                                            {cta?.text ?? ""}
                                        </button>
                                        <Modal
                                            open={isPriceListView}
                                            className="custom-modal-property"
                                            onClose={() => setIsPriceListView(false)}
                                            aria-labelledby="modal-title"
                                            aria-describedby="modal-description"
                                        >
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: "100%",
                                                    height: "100%",
                                                    overflowY: 'auto',
                                                    zIndex: "999999", 
                                                    bgcolor: "#FFFFFF",
                                                    border: "none", 
                                                    p: 0
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    className="btn-close position-absolute top-0 end-0 p-3"
                                                    onClick={() => setIsPriceListView(false)}
                                                    aria-label="Close"
                                                />
                                                <section className="padding-mobile" style={{ padding: '2rem' }}>
                                                    <div className="container-fluid d-flex justify-content-center align-items-center">
                                                        <Accordion defaultActiveKey={null} className="mt-5 accordion-detail w-75">
                                                            {item?.priceLists?.map((price, priceIndex) => (
                                                                <Accordion.Item eventKey={priceIndex.toString()} key={priceIndex} className="mb-3">
                                                                    <Accordion.Header>{price.title?.toUpperCase()}</Accordion.Header>
                                                                    <Accordion.Body>
                                                                        <p
                                                                            className="m-0 mb-2"
                                                                            dangerouslySetInnerHTML={{ __html: price.description }}
                                                                        />
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <p
                                                                                className="m-0"
                                                                                dangerouslySetInnerHTML={{ __html: price.leftInformation }}
                                                                            />
                                                                            <p
                                                                                className="m-0"
                                                                                dangerouslySetInnerHTML={{ __html: price.rightInformation }}
                                                                            />
                                                                        </div>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            ))}
                                                        </Accordion>
                                                    </div>
                                                </section>
                                            </Box>
                                        </Modal>
                                    </>
                                ) 
                                : 
                                cta.url && cta.url.includes("#") ? 
                                (
                                    <HashLink target={cta?.target ?? ""} to={cta?.url ?? ""} className="lineEffect link text-uppercase mb-4">
                                        {cta?.text ?? ""}
                                    </HashLink>
                                )
                                :
                                (
                                <NavLink target={cta?.target ?? ""} to={cta?.url ?? ""} className="lineEffect link text-uppercase mb-4">
                                    {cta?.text ?? ""}
                                </NavLink>
                            )}
                        </div>                                   
                    </div>

                </div>
            </ParallaxBannerLayer>

        </ParallaxBanner>
    );
}

export default AdvancedBanner;